interface LoadingProps {
  message?: string;
  dark?: boolean;
}

export const Loading = ({
  message = "Cargando...",
  dark = false,
}: LoadingProps) => {
  const colorClass = dark ? "text-gray-200" : "text-gray-500";

  return (
    <div
      className={`flex flex-col items-center justify-center py-20 ${colorClass}`}
    >
      <div
        className={`h-10 w-10 animate-spin rounded-full border-4 border-solid border-r-transparent`}
        style={{
          borderColor: `${dark ? "#e5e7eb" : "#6b7280"}`,
          borderRightColor: "transparent",
        }}
        role="status"
      />
      <p className="mt-3 text-base font-medium">{message}</p>
    </div>
  );
};
